module.exports = __webpack_public_path__ + "static/media/woo8.24b784b0.png";